'use client';

import { useState, useEffect } from 'react';
import { getCookieConsent } from '@/utils/cookieConsent';
import { COOKIE_CONSENT_EVENT } from '@/constant/cookie';

export const useCookieConsent = () => {
  const [consentPreferences, setConsentPreferences] = useState({ accepted: false });

  useEffect(() => {
    setConsentPreferences(getCookieConsent());

    const handleStorageChange = () => {
      setConsentPreferences(getCookieConsent());
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener(COOKIE_CONSENT_EVENT, handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener(COOKIE_CONSENT_EVENT, handleStorageChange);
    };
  }, []);

  return consentPreferences;
};
